import { Home, User, Settings, HelpCircle, LucideProps, FileText, Building, Package, Layers, Grid, ToolCaseIcon, Activity, FileMinus, Users, Truck, UserPlus, ShoppingBag, Tag, CreditCard, BarChart, TrendingUp, DollarSign, Monitor, Server, Briefcase, Shield, ShoppingCart } from 'lucide-react'

const Icons = {
    home: Home,
    "file-text": FileText,
    user: User,
    settings: Settings,
    building: Building,
    package: Package,
    layers: Layers,
    grid: Grid,
    tool: ToolCaseIcon,
    activity: Activity,
    "file-minus": FileMinus,
    users: Users,
    truck: Truck,
    "user-plus": UserPlus,
    tag: Tag,
    "shopping-bag": ShoppingBag,
    "credit-card": CreditCard,
    "bar-chart": BarChart,
    "trending-up": TrendingUp,
    "dollar-sign": DollarSign,
    monitor: Monitor,
    server: Server,
    briefcase: Briefcase,
    shield: Shield,
    "shopping-cart": ShoppingCart,
}

type IconProps = {
    iconName: string;
} & LucideProps

const Icon = ({ iconName, ...rest }: IconProps) => {
    // Verifica se o ícone existe
    const IconComponent = Icons[iconName as keyof typeof Icons]

    if (!IconComponent) {
        console.warn(`Ícone "${iconName}" não encontrado. Usando ícone padrão.`)
        return <HelpCircle {...rest} />
    }

    return <IconComponent {...rest} />
}

export default Icon